import(/* webpackMode: "eager" */ "/tmp/8def86a95d1d9d9/app/[locale]/error.tsx");
